import type { IconSvgObject } from './types';

const ViewIcon: IconSvgObject = [
  ["path", { d: "M15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 5C16.1818 5 19.764 9.01321 21.2572 10.9622C21.7314 11.5813 21.7314 12.4187 21.2572 13.0378C19.764 14.9868 16.1818 19 12 19C7.81823 19 4.23598 14.9868 2.74283 13.0378C2.26856 12.4187 2.26857 11.5813 2.74283 10.9622C4.23598 9.01321 7.81823 5 12 5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ViewIcon;
